import { render, staticRenderFns } from "./index.mpx?vue&type=template&id=00616f62&isComponent&outputPath=components%2Findex1b0c1aa7%2Findex"
import script from "./index.mpx?vue&type=script&lang=ts&isComponent&outputPath=components%2Findex1b0c1aa7%2Findex"
export * from "./index.mpx?vue&type=script&lang=ts&isComponent&outputPath=components%2Findex1b0c1aa7%2Findex"
import style0 from "./index.mpx?vue&type=style&index=0&id=00616f62&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_1b0c1aa7%22%7D&isComponent&outputPath=components%2Findex1b0c1aa7%2Findex"


/* normalize component */
import normalizer from "!../../../../../example/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports